import React from "react";
import styled from "styled-components";

const InfoGrid = (props) => <StyledGrid>{props.children}</StyledGrid>;

export default InfoGrid;

const StyledGrid = styled.section`
  fontsize: 14px;
  line-height: 22px;
  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 20px;
  }
`;
